<template>
	<component :is="tag">
		<div class="joined-cells">
			<component v-for="pair in pairs" :is="pair.cc.component" v-bind="cellBind(pair.cc)" :object="object" :col="pair.col"></component>
		</div>
	</component>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import type {DataColumn} from "@t/fd/layout/Agenda.ts";
import {CellComponent} from "@fd/containers/agenda/AgendaUtils.ts";

const props = withDefaults(defineProps<{
	object?: object,
	col: DataColumn[],
	tag?: string,
	/** Components for the columns (col property) in the same order */
	items: CellComponent[]
}>(), { tag: "td" });

interface ColumnComponent {
	col: DataColumn;
	cc: CellComponent;
}
const pairs = computed<ColumnComponent[]>(() => {
	const out:ColumnComponent[] = [];
	const count = Math.min(props.col.length, props.items.length);
	for (let i = 0; i < count; i++) {
		out.push({ col: props.col[i], cc: props.items[i]});
	}
	return out;
});

function cellBind(c:CellComponent) {
	return c.bind ? c.bind : {};
}
</script>

<style>
.joined-cells {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	column-gap: var(--agenda-h-padding);
}
</style>